// ----------------------------------------------------------------------
// <copyright file='Izenda.CancelViewReportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var Button = require('share/components/controls/Izenda.Button');

  var constants = require('logic/data/Izenda.ReportsConstants');
  var connect = require('share/enhancers/Izenda.Connect');

  var CancelViewReportButton = React.createClass({
    render: function() {
      var localization = this.props.localization;
      return <Button className='btn-report-default' label={localization.getText('COMMON_LABEL_CANCEL')} onClick={this.onCancel} />;
    },
    onCancel: function(e) {
      var props = this.props;
      var confirmFn = props.confirmFn;

      return props.checkDirty(null)
        ? confirmFn('Confirmation', {
            description: constants.MESSAGES.CANCEL
          }).then(function() {
            props.cancelReport && props.cancelReport();
          })
        : props.cancelReport && props.cancelReport();
    }
  });

  module.exports = connect()(CancelViewReportButton);
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/Buttons/Izenda.CancelViewReportButton.jsx